const StreamTypes = Object.freeze({
    "velocity": "velocity_smooth",
    "time": "time",
    "distance": "distance",
    "latlng": "latlng",
    "heartrate":"heartrate",
    "cadence": "cadence",
    "altitude": "altitude"
});

export default StreamTypes;